var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkplaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    transform: "translate(-769.000000, -9981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(769.000000, 9981.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-5",
    fill: "#F8EFFF",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-buildings-AFPNQYL2UJ",
    transform: "translate(19.000000, 22.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.22222222 C0,0.994933333 1.02336,0 2.28571429,0 L29.7142857,0 C30.9766857,0 32,0.994933333 32,2.22222222 L32,37.7777778 C32,39.0051111 30.9766857,40 29.7142857,40 C28.4518857,40 27.4285714,39.0051111 27.4285714,37.7777778 L27.4285714,4.44444444 L4.57142857,4.44444444 L4.57142857,37.7777778 C4.57142857,39.0051111 3.54806857,40 2.28571429,40 C1.02336,40 0,39.0051111 0,37.7777778 L0,2.22222222 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1666667,15.4 C12.3632733,15.4 13.3333333,14.415016 13.3333333,13.2 C13.3333333,11.984984 12.3632733,11 11.1666667,11 C9.97006,11 9,11.984984 9,13.2 C9,14.415016 9.97006,15.4 11.1666667,15.4 Z M11.1666667,24.2 C12.3632733,24.2 13.3333333,23.21506 13.3333333,22 C13.3333333,20.78494 12.3632733,19.8 11.1666667,19.8 C9.97006,19.8 9,20.78494 9,22 C9,23.21506 9.97006,24.2 11.1666667,24.2 Z M13.3333333,30.8 C13.3333333,32.01506 12.3632733,33 11.1666667,33 C9.97006,33 9,32.01506 9,30.8 C9,29.58494 9.97006,28.6 11.1666667,28.6 C12.3632733,28.6 13.3333333,29.58494 13.3333333,30.8 Z M19.8333333,15.4 C21.0299833,15.4 22,14.415016 22,13.2 C22,11.984984 21.0299833,11 19.8333333,11 C18.6366833,11 17.6666667,11.984984 17.6666667,13.2 C17.6666667,14.415016 18.6366833,15.4 19.8333333,15.4 Z M22,22 C22,23.21506 21.0299833,24.2 19.8333333,24.2 C18.6366833,24.2 17.6666667,23.21506 17.6666667,22 C17.6666667,20.78494 18.6366833,19.8 19.8333333,19.8 C21.0299833,19.8 22,20.78494 22,22 Z M19.8333333,33 C21.0299833,33 22,32.01506 22,30.8 C22,29.58494 21.0299833,28.6 19.8333333,28.6 C18.6366833,28.6 17.6666667,29.58494 17.6666667,30.8 C17.6666667,32.01506 18.6366833,33 19.8333333,33 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,15.1818182 C27,13.9768436 28.007325,13 29.25,13 L42.75,13 C43.992675,13 45,13.9768436 45,15.1818182 L45,34.8181818 C45,36.0232 43.992675,37 42.75,37 C41.507325,37 40.5,36.0232 40.5,34.8181818 L40.5,17.3636364 L29.25,17.3636364 C28.007325,17.3636364 27,16.3868364 27,15.1818182 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceIcon);
export default __webpack_public_path__ + "static/media/workplace-icon.e946ae562ee409fac5ae38b66bf38e7f.svg";
export { ForwardRef as ReactComponent };